import React, {useCallback, useEffect, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {selectLoadingbarStatus} from '../LoaderSlice.jsx';
import {closeFilter, disableSticky, enableSticky, selectFilterStatus} from '../FilterSlice.jsx';
import FilterOrderingButton from './FilterOrderingButton.jsx';
import Filter from '../filter/Filter.jsx';
import {Constants} from '../view-constants';
import Device from '@core/scripts/components/device';
import useEffectOnUpdate from '../helper/hooks-helper.jsx';
import {useBreakpointUp} from "bonprix-design-system";

export default function FilterOrderingBar({filterContent, landmarkContent, ordering, showOnlyTokens, filterSubmit}) {
    const filterOpened = useSelector(selectFilterStatus).opened;
    const contentLoading = useSelector(selectLoadingbarStatus).status;
    const breakpointLUp = useBreakpointUp('l');
    const isSticky = useSelector(selectFilterStatus).sticky;
    const dispatch = useDispatch();

    const isApp = Device.isApp();
    const scrollSpy = useRef(window.scrollY);
    const rootMargin = useRef(
        isApp
            ? Constants.ROOT_MARGIN_APP
            : breakpointLUp
              ? Constants.ROOT_MARGIN_LARGE
              : Constants.ROOT_MARGIN_SMALL,
    );

    const stickyFilterLine = useRef(null);

    const handleScroll = useCallback(() => {
        const scrollTopStart = window.scrollY || window.pageYOffset || document.body.scrollTop || 0;
        const down = scrollTopStart >= scrollSpy.current;
        const topPosition = stickyFilterLine.current.getBoundingClientRect().top;

        if (down && !isSticky && topPosition < rootMargin.current) {
            dispatch(enableSticky());
        } else if (!down && isSticky && topPosition > rootMargin.current) {
            dispatch(disableSticky());
        }
        scrollSpy.current = scrollTopStart;
    }, [isSticky]);

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [handleScroll]);

    useEffect(() => {
        rootMargin.current = isApp
            ? Constants.ROOT_MARGIN_APP
            : breakpointLUp
              ? Constants.ROOT_MARGIN_LARGE
              : Constants.ROOT_MARGIN_SMALL;
    }, [breakpointLUp]);

    // TODO: in andere Komponente auslagern
    useEffectOnUpdate(() => {
        // close filter accordion after content load
        if (filterOpened && !contentLoading) {
            dispatch(closeFilter());
        }
    }, [contentLoading]);

    const stickyClass = isSticky ? '-is-sticky' : '';
    const stickyDisabled = showOnlyTokens ? '-sticky-disabled' : '';
    const app = isApp ? '-is-app' : '';
    const stickyContainerClasses = `article-overview__filter-order ${stickyClass} ${stickyDisabled} ${app}`;

    return (
        <>
            <div className="sticky-filter-line" ref={stickyFilterLine}></div>

            {!showOnlyTokens && !breakpointLUp && (
                <div className={stickyContainerClasses}>
                    <FilterOrderingButton filterViewValue={landmarkContent?.filterViewLandmark} />
                </div>
            )}
            {isSticky && <div className="article-overview__sticky-separator"></div>}

            <Filter filterContent={filterContent} filterSubmit={filterSubmit} ordering={ordering} />
        </>
    );
}
